import {
  getVehicleDropdownOptionsApi,
  createOutwardVehicleTrackingApi,
  createDuplicateVehicleTrackingApi,
  getDeliveryForBusinessPartnerApi,
  getDeliveryDropdownOptionsApi,
  getCategoryBusinessPartnersDropdownOptionsApi,
  getTransportersDropdownOptionsApi,
  getTransporterDropdownOptionsApi,
  getAttachedDeliveryForOutwardVehicleApi,
  getVehicleDetailsForOutwardApi,
  getVehicleTrackingsForVehicleDetailApi,
  getVehicleTrackingListForPlanningApi,
  getOutwardVehicleTrackingDetailsApi,
  updateVehicleTrackingForOutwardApi,
  getPackTypeForDeliveryLineItemApi,
  createVehicleTrackingLoadHeaderApi,
  getVehicleTrackingAttachedLoadsApi,
  getLoadLineItemsForLoadHeaderApi,
  updateVehicleTrackingLoadLineItemApi,
  updateVehicleTrackingLoadApi,
  getDataForVehicleTrackingLoadCardsApi,
  getCapturedWeightForWeightBridgeEventUuidApi,
  updateVehicleTrackingLoadWeightApi,
  getLoadLineItemsForVehicleTrackingApi,
  confirmVehicleTrackingLoadApi,
  updateVehicleTrackingOnHoldApi,
  validateAndGetDuplicateObjectsForVehicleTrackingApi,
  getAttachedDeliveriesForVehicleTrackingApi,
  updateVehicleTrackingDeliveryAttachmentsApi,
  getProductsApi,
  getAttachedDeliveryLineItemsForVehicleTrackingApi,
  updateVehicleTrackingDetailsApi,
  getVarianceReportForOutwardApi,
  getOutwardReportWithExitTimeApi,
  updateVehicleTrackingStatusApi,
  getReasonsDropdownOptionsForVehicleTrackingApi,
} from 'src/api/vehicleTrackingOutwardApi';
import {
  GET_VEHICLE_DROPDOWN_OPTIONS,
  CREATE_VEHICLE_TRACKING_OUTWARD,
  CREATE_DUPLICATE_VEHICLE_TRACKING,
  GET_DELIVERY_FOR_BUSINESS_PARTNER,
  GET_DELIVERY_DROPDOWN_OPTIONS,
  RESET_DELIVERY_LIST_FOR_VEHICLE_NUMBER,
  RESET_VEHICLE_DROPDOWN_OPTIONS,
  GET_CATEGORY_BASED_BUSINESS_PARTNER,
  GET_TRANSPORTER_DATA,
  GET_TRANSPORTER_DROPDOWN_OPTIONS,
  GET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE,
  RESET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE,
  GET_VEHICLE_DETAILS_FOR_OUTWARD,
  GET_VEHICLE_TRACKINGS_FOR_VEHICLE_DETAIL,
  RESET_VEHICLE_DETAILS,
  GET_VEHICLE_TRACKING_LIST_FOR_PLANNING,
  GET_OUTWARD_VEHICLE_TRACKING_DETAILS,
  UPDATE_VEHICLE_TRACKING_FOR_OUTWARD,
  RESET_DELIVERY_FOR_BUSINESS_PARTNER,
  RESET_OUTWARD_VEHICLE_TRACKING_DETAILS,
  GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM,
  CREATE_VEHICLE_TRACKING_LOAD_HEADER,
  GET_VEHICLE_TRACKING_ATTACHED_LOADS,
  GET_LOAD_LINE_ITEMS_FOR_LOAD_HEADER,
  UPDATE_VEHICLE_TRACKING_LOAD_LINE_ITEM,
  UPDATE_VEHICLE_TRACKING_LOAD,
  GET_DATA_FOR_VEHICLE_TRACKING_LOAD_CARDS,
  GET_CAPTURED_WEIGHT_FOR_WEIGHT_BRIDGE_EVENT_UUID,
  UPDATE_VEHICLE_TRACKING_LOAD_WEIGHT,
  GET_LOAD_LINE_ITEMS_FOR_VEHICLE_TRACKING,
  CONFIRM_VEHICLE_TRACKING_LOAD,
  UPDATE_VEHICLE_TRACKING_ON_HOLD,
  VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING,
  GET_ATTACHED_DELIVERIES_FOR_VEHICLE_TRACKING,
  UPDATE_VEHICLE_TRACKING_DELIVERY_ATTACHMENTS,
  GET_PRODUCTS,
  RESET_GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM,
  GET_ATTACHED_DELIVERY_LINE_ITEMS_FOR_VEHICLE_TRACKING,
  UPDATE_VEHICLE_TRACKING_DETAILS,
  GET_VARIANCE_REPORT_FOR_OUTWARD,
  GET_OUTWARD_REPORT_WITH_EXIT_TIME,
  UPDATE_VEHICLE_TRACKING_STATUS,
  GET_REASONS_DROPDOWN_OPTIONS_FOR_VEHICLE_TRACKING,
} from 'src/redux/Actions/Type';

export const getVehicleDropdownOptions =
  (tenantOrganisationId, vehicleSearchTerm, transporterId) => (dispatch) =>
    getVehicleDropdownOptionsApi(
      tenantOrganisationId,
      vehicleSearchTerm,
      transporterId,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_DROPDOWN_OPTIONS,
        payload: data,
      });
    });

export const resetVehicleDropdownOptions = () => ({
  type: RESET_VEHICLE_DROPDOWN_OPTIONS,
});

export const createOutwardVehicleTracking = (payload) => (dispatch) =>
  createOutwardVehicleTrackingApi(payload).then((data) => {
    dispatch({
      type: CREATE_VEHICLE_TRACKING_OUTWARD,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const createDuplicateVehicleTracking = (payload) => (dispatch) =>
  createDuplicateVehicleTrackingApi(payload).then((data) => {
    dispatch({
      type: CREATE_DUPLICATE_VEHICLE_TRACKING,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const getDeliveryForBusinessPartner = (searchData) => (dispatch) =>
  getDeliveryForBusinessPartnerApi(searchData).then((data) => {
    dispatch({
      type: GET_DELIVERY_FOR_BUSINESS_PARTNER,
      payload: data,
    });
  });

export function getDeliveryDropdownOptions(
  tenantOrganisationId,
  vehicleNumber,
  pageNumber,
  paginationBatchSize,
  deliveryStartDate,
  deliveryEndDate,
  productSapCode,
  searchTerm,
  updateStore = true,
) {
  return (dispatch) =>
    getDeliveryDropdownOptionsApi(
      tenantOrganisationId,
      vehicleNumber,
      pageNumber,
      paginationBatchSize,
      deliveryStartDate,
      deliveryEndDate,
      productSapCode,
      searchTerm,
    ).then((data) => {
      if (updateStore) {
        dispatch({
          type: GET_DELIVERY_DROPDOWN_OPTIONS,
          payload: data,
        });
      }

      return Promise.resolve(data);
    });
}

export const resetDeliveryForBusinessPartner = () => ({
  type: RESET_DELIVERY_FOR_BUSINESS_PARTNER,
});

export const resetDeliveryListForVehicleNumber = () => ({
  type: RESET_DELIVERY_LIST_FOR_VEHICLE_NUMBER,
});

export const getCategoryBusinessPartnersDropdownOptions =
  (tenantOrganisationId, searchTerm, categoryKeyId) => (dispatch) =>
    getCategoryBusinessPartnersDropdownOptionsApi(
      tenantOrganisationId,
      searchTerm,
      categoryKeyId,
    ).then((data) => {
      dispatch({
        type: GET_CATEGORY_BASED_BUSINESS_PARTNER,
        payload: data,
      });
    });

export const getTransportersDropdownOptions =
  (tenantOrganisationId, searchTerm) => (dispatch) =>
    getTransportersDropdownOptionsApi(tenantOrganisationId, searchTerm).then(
      (data) => {
        dispatch({
          type: GET_TRANSPORTER_DATA,
          payload: data,
        });
      },
    );

export const getTransporterDropdownOptions =
  (tenantOrganisationId, searchTerm, vehicleId) => (dispatch) =>
    getTransporterDropdownOptionsApi(
      tenantOrganisationId,
      searchTerm,
      vehicleId,
    ).then((data) => {
      dispatch({
        type: GET_TRANSPORTER_DROPDOWN_OPTIONS,
        payload: data,
      });
    });

export const getAttachedDeliveryForOutwardVehicle =
  (tenantOrganisationId, vehicleId, todayDate) => (dispatch) =>
    getAttachedDeliveryForOutwardVehicleApi(
      tenantOrganisationId,
      vehicleId,
      todayDate,
    ).then((data) => {
      dispatch({
        type: GET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE,
        payload: data,
      });
    });

export const resetAttachedDeliveryForOutwardVehicle = () => ({
  type: RESET_ATTACHED_DELIVERY_FOR_OUTWARD_VEHICLE,
});

export const getVehicleDetailsForOutward =
  (tenantOrganisationId, vehicleId) => (dispatch) =>
    getVehicleDetailsForOutwardApi(tenantOrganisationId, vehicleId).then(
      (data) => {
        dispatch({
          type: GET_VEHICLE_DETAILS_FOR_OUTWARD,
          payload: data,
        });
      },
    );

export function getVehicleTrackingsForVehicleDetail(
  tenantOrganisationId,
  vehicleId,
  vehicleTrackingStatus,
  pageNumber,
  paginationBatchSize,
  filters,
) {
  return (dispatch) =>
    getVehicleTrackingsForVehicleDetailApi(
      tenantOrganisationId,
      vehicleId,
      vehicleTrackingStatus,
      pageNumber,
      paginationBatchSize,
      filters,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKINGS_FOR_VEHICLE_DETAIL,
        payload: {
          status: vehicleTrackingStatus,
          data,
        },
      });
      return Promise.resolve(data);
    });
}

export const resetVehicleDetails = () => ({
  type: RESET_VEHICLE_DETAILS,
});

export function getVehicleTrackingListForPlanning(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getVehicleTrackingListForPlanningApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_LIST_FOR_PLANNING,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const getOutwardVehicleTrackingDetails =
  (vehicleTrackingNumber, tenantOrganisationId) => (dispatch) =>
    getOutwardVehicleTrackingDetailsApi(
      vehicleTrackingNumber,
      tenantOrganisationId,
    ).then((data) => {
      dispatch({
        type: GET_OUTWARD_VEHICLE_TRACKING_DETAILS,
        payload: data,
      });
    });

export const resetOutwardVehicleTrackingDetails = () => ({
  type: RESET_OUTWARD_VEHICLE_TRACKING_DETAILS,
});

export const updateVehicleTrackingForOutward = (updateData) => (dispatch) =>
  updateVehicleTrackingForOutwardApi(updateData).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_FOR_OUTWARD,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const getPackTypeForDeliveryLineItem =
  (tenantOrganisationId, deliveryLineItemId) => (dispatch) =>
    getPackTypeForDeliveryLineItemApi(
      tenantOrganisationId,
      deliveryLineItemId,
    ).then((data) => {
      dispatch({
        type: GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM,
        payload: data,
      });
    });

export const resetGetPackTypeForDeliveryLineItem = () => ({
  type: RESET_GET_PACK_TYPE_FOR_DELIVERY_LINE_ITEM,
});

export const createVehicleTrackingLoadHeader = (payload) => (dispatch) =>
  createVehicleTrackingLoadHeaderApi(payload).then((data) => {
    dispatch({
      type: CREATE_VEHICLE_TRACKING_LOAD_HEADER,
      payload: data,
    });
  });

export const getVehicleTrackingAttachedLoads =
  (tenantOrganisationId, vehicleTrackingNumber) => (dispatch) =>
    getVehicleTrackingAttachedLoadsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_VEHICLE_TRACKING_ATTACHED_LOADS,
        payload: data,
      });
    });

export const getLoadLineItemsForLoadHeader =
  (tenantOrganisationId, vtLoadHeaderUniqueNumber) => (dispatch) =>
    getLoadLineItemsForLoadHeaderApi(
      tenantOrganisationId,
      vtLoadHeaderUniqueNumber,
    ).then((data) => {
      dispatch({
        type: GET_LOAD_LINE_ITEMS_FOR_LOAD_HEADER,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const updateVehicleTrackingLoadLineItem = (payload) => (dispatch) =>
  updateVehicleTrackingLoadLineItemApi(payload).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_LOAD_LINE_ITEM,
      payload: data,
    });
  });

export const updateVehicleTrackingLoad = (payload) => (dispatch) =>
  updateVehicleTrackingLoadApi(payload).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_LOAD,
      payload: data,
    });
    return Promise.resolve(data);
  });

export function getDataForVehicleTrackingLoadCards(
  tenantOrganisationId,
  vehicleTrackingNumber,
  vtLoadHeaderUniqueNumber,
) {
  return (dispatch) =>
    getDataForVehicleTrackingLoadCardsApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      vtLoadHeaderUniqueNumber,
    ).then((data) => {
      dispatch({
        type: GET_DATA_FOR_VEHICLE_TRACKING_LOAD_CARDS,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getCapturedWeightForWeightBridgeEventUuid(
  tenantOrganisationId,
  vtLoadHeaderUniqueNumber,
  weightBridgeEventUUID,
  vehicleTrackingNumber,
  fieldVerboseName,
) {
  return (dispatch) =>
    getCapturedWeightForWeightBridgeEventUuidApi(
      tenantOrganisationId,
      vtLoadHeaderUniqueNumber,
      weightBridgeEventUUID,
      vehicleTrackingNumber,
      fieldVerboseName,
    ).then((data) => {
      dispatch({
        type: GET_CAPTURED_WEIGHT_FOR_WEIGHT_BRIDGE_EVENT_UUID,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const updateVehicleTrackingLoadWeight = (payload) => (dispatch) =>
  updateVehicleTrackingLoadWeightApi(payload).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_LOAD_WEIGHT,
      payload: data,
    });
  });

export const getLoadLineItemsForVehicleTracking =
  (tenantOrganisationId, vehicleTrackingNumber) => (dispatch) =>
    getLoadLineItemsForVehicleTrackingApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_LOAD_LINE_ITEMS_FOR_VEHICLE_TRACKING,
        payload: data,
      });
    });

export const confirmVehicleTrackingLoad = (payload) => (dispatch) =>
  confirmVehicleTrackingLoadApi(payload).then((data) => {
    dispatch({
      type: CONFIRM_VEHICLE_TRACKING_LOAD,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const updateVehicleTrackingOnHold = (payload) => (dispatch) =>
  updateVehicleTrackingOnHoldApi(payload).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_ON_HOLD,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const validateAndGetDuplicateObjectsForVehicleTracking =
  (payload) => (dispatch) =>
    validateAndGetDuplicateObjectsForVehicleTrackingApi(payload)
      .then((response) => {
        dispatch({
          type: VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING,
          payload: response,
        });
        return Promise.resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: VALIDATE_AND_GET_DUPLICATE_OBJECTS_FOR_VEHICLE_TRACKING,
          payload: { error: true, message: error.message },
        });
        return Promise.reject(error);
      });

export function getAttachedDeliveriesForVehicleTracking(
  tenantOrganisationId,
  vehicleTrackingNumber,
) {
  return (dispatch) =>
    getAttachedDeliveriesForVehicleTrackingApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
    ).then((data) => {
      dispatch({
        type: GET_ATTACHED_DELIVERIES_FOR_VEHICLE_TRACKING,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export function getAttachedDeliveryLineItemsForVehicleTracking(
  tenantOrganisationId,
  vehicleTrackingNumber,
  productId,
  businessPartnerId,
) {
  return (dispatch) =>
    getAttachedDeliveryLineItemsForVehicleTrackingApi(
      tenantOrganisationId,
      vehicleTrackingNumber,
      productId,
      businessPartnerId,
    ).then((data) => {
      dispatch({
        type: GET_ATTACHED_DELIVERY_LINE_ITEMS_FOR_VEHICLE_TRACKING,
        payload: data,
      });
      return Promise.resolve(data);
    });
}

export const updateVehicleTrackingDeliveryAttachments =
  (payload) => (dispatch) =>
    updateVehicleTrackingDeliveryAttachmentsApi(payload).then((data) => {
      dispatch({
        type: UPDATE_VEHICLE_TRACKING_DELIVERY_ATTACHMENTS,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const getProducts = (tenantOrganisationId, searchTerm) => (dispatch) =>
  getProductsApi(tenantOrganisationId, searchTerm).then((data) => {
    dispatch({
      type: GET_PRODUCTS,
      payload: data,
    });
    return data;
  });

export const updateVehicleTrackingDetails = (payload) => (dispatch) =>
  updateVehicleTrackingDetailsApi(payload).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_DETAILS,
      payload: data,
    });
    return Promise.resolve(data);
  });

export function getOutwardReportWithExitTime(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getOutwardReportWithExitTimeApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_OUTWARD_REPORT_WITH_EXIT_TIME,
        payload: data,
      });
      return data;
    });
}

export function getVarianceReportForOutward(
  tenantOrganisationId,
  pageNumber,
  searchInput,
  tableSortOrder,
  tableSortField,
  tableFieldFilter,
  paginationBatchSize,
  queryString,
) {
  return (dispatch) =>
    getVarianceReportForOutwardApi(
      tenantOrganisationId,
      pageNumber,
      searchInput,
      tableSortOrder,
      tableSortField,
      tableFieldFilter,
      paginationBatchSize,
      queryString,
    ).then((data) => {
      dispatch({
        type: GET_VARIANCE_REPORT_FOR_OUTWARD,
        payload: data,
      });
      return data;
    });
}

export const updateVehicleTrackingStatus = (payload) => (dispatch) =>
  updateVehicleTrackingStatusApi(payload).then((data) => {
    dispatch({
      type: UPDATE_VEHICLE_TRACKING_STATUS,
      payload: data,
    });
    return Promise.resolve(data);
  });

export function getReasonsDropdownOptionsForVehicleTracking(
  tenantOrganisationId,
  documentType,
) {
  return (dispatch) =>
    getReasonsDropdownOptionsForVehicleTrackingApi(
      tenantOrganisationId,
      documentType,
    ).then((data) => {
      dispatch({
        type: GET_REASONS_DROPDOWN_OPTIONS_FOR_VEHICLE_TRACKING,
        payload: data,
      });
      return Promise.resolve(data);
    });
}
